import { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import dateFormat from 'dateformat';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { BootstrapTable } from '@components/Table/Table';

const renderActionCell = ({ row }) => {
  const { fileLocation } = row.original;
  return (
    <Button
      as={Link}
      to={fileLocation}
      target="_blank"
      variant="didxl"
      size="sm"
      disabled={!fileLocation}
    >
      View
    </Button>
  );
};

const renderDocumentStatusCell = ({ value }) => {
  if (value === 'Rejected') {
    return <span className="textRed">{value}</span>;
  }
  return value;
};

export const DocumentsTable = ({ data, isLoading }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Document Type',
        accessor: 'documentType.name',
        className: 'col-md-4',
      },
      {
        Header: 'Validated',
        accessor: 'validated',
        className: 'col-md-1',
      },
      {
        Header: 'Status',
        accessor: 'active',
        className: 'col-md-2',
        Cell: renderDocumentStatusCell,
      },
      {
        Header: 'Submitted',
        accessor: 'submitted',
        className: 'col-md-2',
        Cell: ({ value }) => {
          if (!value) {
            return null;
          }
          const date = new Date(value);
          return dateFormat(date, 'defaultDateTime');
        },
      },
      {
        Header: 'File Name',
        accessor: 'fileName',
        className: 'col-md-2',
      },
      {
        Header: 'Action',
        className: 'col-md-1',
        Cell: renderActionCell,
      },
    ],
    []
  );
  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }

  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({ responsive: true, bordered: true })}
    />
  );
};
